import './styles/base-styles.scss';
import ATPAppRoutes from './app/routes';
import React from 'react';

function App () {

    return (
        <div>
            <ATPAppRoutes />
        </div>
    );

}

export default App;
